import { api } from './api'
import { DashboardStats } from '@/types'

export interface ActivityItem {
  id: number
  type: 'campaign_started' | 'campaign_completed' | 'client_imported' | 'template_created'
  message: string
  timestamp: string
  metadata?: Record<string, any>
}

export interface ChartDataPoint {
  date: string
  sent: number
  delivered: number
  opened: number
  replied: number
}

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await api.get<{ success: boolean; data: DashboardStats; message: string }>('/admin/dashboard')
    return response.data.data
  },

  async getRecentActivity(limit: number = 10): Promise<ActivityItem[]> {
    const response = await api.get<{ success: boolean; data: ActivityItem[]; message: string }>('/admin/activity', {
      params: { limit },
    })
    return response.data.data
  },

  async getEmailChartData(days: number = 7): Promise<ChartDataPoint[]> {
    const response = await api.get<ChartDataPoint[]>('/admin/analytics/overview', {
      params: { days },
    })
    return response.data
  },

  async getPerformanceMetrics(): Promise<{
    deliveryRate: number
    openRate: number
    replyRate: number
    bounceRate: number
  }> {
    const response = await api.get('/admin/analytics/performance')
    return response.data
  },
}
